<template>
  <div class="captuerWrap">
    <Loading class="loading" type="fixed" :visible="true">
      <p class="loadingText">PDF 파일을 생성 중 입니다.</p>
    </Loading>
    <WikiViewer :wikiIndex="false" :Data="viewData" ref="wikiViwer"
      @load-content="loadMounted"
    ></WikiViewer>
    <pdf-wiki ref="pdfWiki" :contentImages="images"/>
    
  </div>
  
</template>

<script>
import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import WikiViewer from '@components/platform_new/testWikiViewer.vue';
import pdfDOMMakeFunc from '@mixins/domToPdf.js'
import pdfDOMMakeFunc2 from '@mixins/domToPdf2.js'
import PDFWiki from "@components/pdf/PDFWiki";
import Loading from '@common/loading.vue'

export default {
  name: 'WikiPdfDownload',
  components: {
    Loading,
    WikiViewer,
    'pdf-wiki' : PDFWiki , 
  },
  mixins: [CommNew],
  data() {
    return {
      loading: true,
      viewData : {},
      images: null,
      titleImages: null,
      headImages: null,
      canvas: null,
      titleCanvas: null,
      headCanvas: null
    }
  },
  async mounted() {
    const {processId, protocolId, TAKey, isPublish } = this.$route.query;
    this.viewData = {
      processId : processId, 
      protocolId : protocolId,
      TAKey : TAKey,
      isPublish : isPublish,
    }
  },
  methods:{
    loadMounted(status) {
      if(!status || !status.status) return
      this.pdfTest();
    },
    pdfTest() {
      setTimeout( async ()=>{
        const a = await pdfDOMMakeFunc2(this.$refs.wikiViwer.$refs.wikiTitle, 120);
        this.titleImages = a.imageList;
        this.titleCanvas = a.canvasList;
        const b = await pdfDOMMakeFunc2(this.$refs.wikiViwer.$refs.wikiHeader, 60);
        this.headImages = b.imageList;
        this.headCanvas = b.canvasList;
        this.$refs.wikiViwer.$refs.wikiTitle.remove();
        const {imageList, canvasList} = await pdfDOMMakeFunc(this.$refs.wikiViwer.$refs.scrollWrap);
        this.images = imageList;
        this.canvas = canvasList;
        await this.$refs.pdfWiki.printReady({processId:this.$route.query.processId, protocolId:this.$route.query.protocolId ,keyOfProtocol:this.$route.query.key},"open", this.images, this.titleImages, this.headImages);
        window.close();
      }, 1000 );
    },
  }
}
</script>

<style lang="scss" scoped>
.captuerWrap {
  background-color: #fff;
  .loading {
    background-color: #fff;
    position: absolute; top:0; left:0; right:0; bottom:0;
    z-index: 5;
  }
}
.captureImages {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  background-color: #ddd;
  border-bottom: blue;
  img {
    &+img{
      border-top: 1px solid red
    }
  }
}
#app {
  .wikiViewerWrap {
    display: block;
    position: fixed; top:0;
    z-index: -1;
    width:1200px;
    // h1,h2,h3,p,span {
    //   line-height: 1.5;
    // }
    .contentsWrap { display: block; 
      width:1200px;
      // height: 1560px;
      // overflow: auto;
    } 
   
  }
  .loadingText {
    font-weight: bold;
    margin-right: 15px;
  }
}
</style>